module.exports = __webpack_public_path__ + "static/media/pandaisia_thumb1.e95cfb4e.jpg";